import { React } from "react";
import ReactApexChart from "react-apexcharts";
import { Box } from "@material-ui/core";

import useStatNewSubs from "../../../../hooks/useStatNewSubs";
import useStatTotalTrans from "../../../../hooks/useStatTotalTrans";
import moment from "moment";
import { useTranslate } from "react-admin";

//const dateFormat = require("dateformat");
const CHART_HEIGHT = 240;

function LineChart({ periodType, fromDate, toDate }) {
  const translate = useTranslate();
  const {
    newSubs,
    loading: newSubsLoading,
    error: newSubsError,
  } = useStatNewSubs(periodType, fromDate, toDate);

  // const {
  //   members: newSubs,
  //   loading: newSubsLoading,
  //   error: newSubsError,
  // } = useStatMembers(periodType, fromDate, toDate);

  const {
    totalTrans,
    loading: totalTransLoading,
    error: totalTransError,
  } = useStatTotalTrans(periodType, fromDate, toDate);
  if (newSubsLoading || totalTransLoading || totalTrans === null) return null;
  if (newSubsError || totalTransError) return null;

  const [seriesMemberData, seriesWalkInData, xAxisData] =
    createDataCategoryStyle(newSubs, totalTrans, periodType);

  let seriesTotalData = seriesMemberData.map((elementData, index) => {
    return elementData + seriesWalkInData[index];
  });
  let series = [
    {
      name: translate("ra.text.bi.members"),
      data: seriesMemberData,
    },
    {
      name: translate("ra.text.bi.walkIn"),
      data: seriesWalkInData,
    },
    {
      name: translate("ra.text.bi.total"),
      data: seriesTotalData,
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      show: true,
    },
    legend: {
      show: true,
      position: "top",
      offsetY: 5,
      onItemClick: {
        toggleDataSeries: false,
      },
    },
    stroke: {
      curve: "smooth",
    },
    yaxis: {
      title: {
        text: "Customers",
      },
      labels: {
        formatter: function (value) {
          if (!value) return 0;
          return value.toLocaleString();
        },
      },
      axisBorder: {
        show: true,

        offsetX: -1,
        offsetY: 0,
      },
    },
    xaxis: {
      type: "category",
      categories: xAxisData,
      labels: {
        formatter: function (value) {
          if (!value) return "";
          if (value === "All") return "All";
          return moment(value).format(getDateFormat(periodType));
        },
      },
    },
    colors: ["#FA9917", "#2B3E6C", "#C4C4C4"],
    fill: {
      opacity: 1,
    },
    tooltip: {
      x: {
        format: "dd/MM/yy",
      },
      y: {
        format: (value) => {
          if (!value) return 0;
          return value.toLocaleString();
        },
      },
    },
  };

  return (
    <Box>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={CHART_HEIGHT}
      />
    </Box>
  );
}

const getDateFormat = (periodType) => {
  if (periodType === "Day") return "DD MMM YYYY";
  else if (periodType === "Month") return "MMM";
  else if (periodType === "Year") return "YYYY";
  else return "DD MMM YYYY";
};

// const createDataStyle = (members, periodType) => {
//   let seriesMemberData = [];
//   if (periodType === "All") {
//     if (members && members.length > 0) {
//       seriesMemberData.push(members[0].total[0].count);
//     } else seriesMemberData.push(0);
//   }
// };

const createDataCategoryStyle = (newSubs, totalTrans, periodType) => {
  let seriesMemberData = [],
    seriesWalkInData = [],
    xAxisData = [];

  //generate axis data
  if (periodType === "All") {
    xAxisData.push("All");
    if (!newSubs || newSubs.length === 0) seriesMemberData.push(0);
    else seriesMemberData.push(newSubs[0].value);
    if (!totalTrans?.total_trans || totalTrans?.total_trans.length === 0)
      seriesWalkInData.push(0);
    else seriesWalkInData.push(totalTrans?.total_trans[0]?.value ?? 0);
    return [seriesMemberData, seriesWalkInData, xAxisData];
  } else {
    const xAxisMembers = newSubs?.map((e) => e.time) ?? [];
    const xAxisWalkin = totalTrans?.total_trans?.map((e) => e.time) ?? [];

    xAxisData = [...new Set([...xAxisMembers, ...xAxisWalkin])].sort(
      (a, b) => new Date(a) - new Date(b)
    );
  }

  //moment(e.time).format(getDateFormat(periodType))
  xAxisData.forEach((x) => {
    const index = newSubs?.findIndex((newSub) => newSub.time === x);
    if (index > -1) {
      seriesMemberData.push(newSubs[index].value);
    } else {
      seriesMemberData.push(0);
    }

    const indexWalkin = totalTrans?.total_trans?.findIndex(
      (walk) => walk.time === x
    );
    if (indexWalkin > -1) {
      if (!totalTrans?.total_trans[indexWalkin].segment.customerType)
        seriesWalkInData.push(0);
      else {
        const guest = Object.values(
          totalTrans?.total_trans[indexWalkin].segment.customerType
        ).find((value) => value.name === "Guest");

        seriesWalkInData.push(guest.value ?? 0);
      }
    } else {
      seriesMemberData.push(0);
    }
  });

  // newSubs?.forEach((element) => {

  //   seriesMemberData.push(element.value);
  // // });
  // totalTrans?.total_trans?.forEach((element) => {
  //   if (!element.segment.customerType) {
  //     seriesWalkInData.push(0);
  //     return;
  //   }
  //   const guest = Object.values(element.segment.customerType).find(
  //     (value) => value.name === "Guest"
  //   );

  //   seriesWalkInData.push(guest.value ?? 0);
  // });

  return [seriesMemberData, seriesWalkInData, xAxisData];
};

export default LineChart;
